import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

interface ActionTextProps {
  onClick?: () => void;
  icon?: IconDefinition;
  text: string;
  isActive?: boolean;
}

export const ActionText = ({
  onClick,
  icon,
  text,
  isActive,
}: ActionTextProps) => {
  return (
    <div
      onClick={onClick}
      className={`flex items-center gap-[8px] smallt cursor-pointer transition-all relative bigt ${
        isActive ? "text-brand-2" : " hover:hover:text-brand-2"
      }`}
    >
      <p>{text}</p>
      {icon && (
        <FontAwesomeIcon icon={icon} className="text-[16px] text-brand-2" />
      )}
      {isActive && (
        <div className="absolute bottom-[-18px] w-full h-[2px] bg-brand-2"></div>
      )}
    </div>
  );
};
